var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { MultiDayTimelineView, defaultProps as multiDayViewDefaultProps } from './MultiDayTimelineView';
import { messages, timelineViewTitle } from '../../messages';
/**
 * Represents the KendoReact [TimelineView]({% slug timeline_view_scheduler %}) Component.
 */
export var TimelineView = function (props) { return React.createElement(MultiDayTimelineView, __assign({}, props)); };
/** @hidden */
export var defaultProps = {
    name: 'timeline',
    title: function (localization) { return localization.toLanguageString(timelineViewTitle, messages[timelineViewTitle]); },
    dateRange: multiDayViewDefaultProps.dateRange,
    step: 1,
    slotDuration: 60,
    slotDivisions: 2,
    numberOfDays: 1,
    selectedDateFormat: '{0:D}',
    selectedShortDateFormat: '{0:d}'
};
TimelineView.defaultProps = defaultProps;
TimelineView.displayName = 'KendoReactSchedulerTimelineView';
//# sourceMappingURL=TimelineView.js.map